import { Link } from 'react-router-dom';
import logo1 from "../../../assets/img/logo-3.png";
import logo2 from "../../../assets/img/logo-2.png";
import Social from '../../../data/social';

const MobileMenuOne = ({ isOpen, setIsOpen }) => {

    const handleClick = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        setIsOpen(false);
    };

    return (
        <div className={`menu__bar-popup mobile-menu-modern ${isOpen ? "show" : ""}`}>
            <div className="menu__bar-popup-top d-flex justify-content-between align-items-center">
                <div className="logo">
                    <Link to="/" onClick={handleClick}>
                        <img className='dark-n' src={logo1} alt="logo" />
                        <img className='light-n' src={logo2} alt="logo" />
                    </Link>
                </div>
                <div className="close" onClick={() => setIsOpen(false)}>
                <i class="fa-regular fa-xmark"></i>
                </div>
            </div>
            <div className="d-flex flex-column align-items-center gap-4 mt-4">

                <div className="footer__four-menu d-flex flex-column align-items-center gap-3">
                    <Link to="/" onClick={handleClick}>
                        <span className='footer__four-menu-item'>Anasayfa</span>
                    </Link>
                    <Link to="/hakkimizda" onClick={handleClick}>
                        <span className='footer__four-menu-item'>Hakkımızda</span>
                    </Link>
                    <Link to="/projeler" onClick={handleClick}>
                        <span className='footer__four-menu-item'>Projeler</span>
                    </Link>
                    <Link to="/iletisim" onClick={handleClick}>
                        <span className='footer__four-menu-item'>İletişim</span>
                    </Link>
                </div>
                <div className="copyright__area-social text-center">
                    <Social />
                </div>
                <div className="copyright__area-content text-center">
                    <p>© 2026, Ayyıldız İnşaat. Tüm hakları saklıdır.</p>
                </div>
            </div>
        </div>
    );
};

export default MobileMenuOne;